/**
 * Created by Carsten Bühler
 * User: CBuehler on 28.01.2016
 * Copyright: xdot GmbH 2015
 */

import NamedPropStore from './NamedPropStore';
import PageSelectedStore from './PageSelectedStore';
import DlFileEntryStore from './DlFileEntryStore';
import AssetLinkStore from './AssetLinkStore';
import AssetTagStore from './AssetTagStore';
import ModalStore from './ModalStore';
import TitleStore from './TitleStore';
import ReferenceValueStore from './ReferenceValueStore';
import GroupSchemaStore from './GroupSchemaStore';
import BomListStore from './BomListStore';
import NamedListStore from './NamedListStore';
import FliwasPermissionStore from './FliwasPermissionStore';

let namedPropStoreInstance;

export function getNamedPropStore(AppContext) {
    return namedPropStoreInstance || (namedPropStoreInstance = AppContext.createStore(NamedPropStore));
}

let pageSelectedStoreInstance;

export function getPageSelectedStore(AppContext) {
    return pageSelectedStoreInstance || (pageSelectedStoreInstance = AppContext.createStore(PageSelectedStore));
}

let dlFileEntryStoreInstance;

export function getDLFileEntryStore(AppContext) {
    return dlFileEntryStoreInstance || (dlFileEntryStoreInstance = AppContext.createStore(DlFileEntryStore));
}

let assetLinkStoreInstance;

export function getAssetLinkStore(AppContext) {
    return assetLinkStoreInstance || (assetLinkStoreInstance = AppContext.createStore(AssetLinkStore));
}

let assetTagStoreInstance;

export function getAssetTagStore(AppContext) {
    return assetTagStoreInstance || (assetTagStoreInstance = AppContext.createStore(AssetTagStore));
}

let modalStoreInstance;

export function getModalStore(AppContext) {
    return modalStoreInstance || (modalStoreInstance = AppContext.createStore(ModalStore));
}

let titleStoreInstance;

export function getTitleStore(AppContext) {
    return titleStoreInstance || (titleStoreInstance = AppContext.createStore(TitleStore));
}

let referenceValueInstance;

export function getReferenceValueStore(AppContext) {
    return referenceValueInstance || (referenceValueInstance = AppContext.createStore(ReferenceValueStore));
}

let groupSchemaStoreInstance;

export function getGroupSchemaStore(AppContext) {
    return groupSchemaStoreInstance || (groupSchemaStoreInstance = AppContext.createStore(GroupSchemaStore));
}

let bomListStoreInstance;

export function getBomListStore(AppContext) {
    return bomListStoreInstance || (bomListStoreInstance = AppContext.createStore(BomListStore));
}

let namedListStoreInstance;

export function getNamedListStore(AppContext) {
    return namedListStoreInstance || (namedListStoreInstance = AppContext.createStore(NamedListStore));
}

let fliwasPermissionStoreInstance;

export function getFliwasPermissionStore(AppContext) {
    return fliwasPermissionStoreInstance || (fliwasPermissionStoreInstance = AppContext.createStore(FliwasPermissionStore));
}



// WEBPACK FOOTER //
// ./js/stores/StoreFactory.js